import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "../../contexts/AdminAuthContext";
import { Loader2 } from "lucide-react";

export const AdminProtectedRoute = ({ children }) => {
    const { user, loading } = useAdminAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div
                data-testid="admin-loading"
                className="min-h-screen bg-[#050505] text-zinc-400 flex items-center justify-center"
            >
                <Loader2 className="animate-spin text-gold mr-3" size={20} />
                <span className="font-inter text-sm">Verifying session…</span>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }

    return children;
};

export default AdminProtectedRoute;
